// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { TemplateSectionOut } from './templateSectionOut.zod.ts';

export const TemplateOut = zod.object({
  "kind": zod.string(),
  "sections": zod.array(TemplateSectionOut)
});

export type TemplateOut = zod.input<typeof TemplateOut>;
export type TemplateOutOutput = zod.output<typeof TemplateOut>;
